"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var address_1 = require("@celo/base/lib/address");

exports.getAbiByName = function (abi, methodName) {
  return abi.find(function (entry) {
    return entry.name === methodName;
  });
};

exports.parseDecodedParams = function (params) {
  var args = new Array(params.__length__);
  delete params.__length__;
  Object.keys(params).forEach(function (key) {
    var argIndex = parseInt(key, 10);

    if (argIndex >= 0) {
      args[argIndex] = params[key];
      delete params[key];
    }
  });
  return {
    args: args,
    params: params
  };
};

exports.decodeStringParameter = function (ethAbi, str) {
  return ethAbi.decodeParameter('string', address_1.ensureLeading0x(str));
};